import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';

export const useStyles = createUseStyles((theme: Theme) => ({
    form: { display: 'flex', flexDirection: 'column', gap: 12, paddingTop: 4 },
    sectionTitle: {
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        color: theme.custom.color.text.secondary,
        marginTop: 4,
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gap: 12,
        [theme.custom.mq.xs]: { gridTemplateColumns: '1fr' },
    },
    wide: { gridColumn: '1 / -1' },
}));
